import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';



class ShopHeader extends Component {
constructor(props){
    super()
    this.state={favorite:false,balance:0}

}



componentDidMount(){
    this.loadHeader()
  
}


async loadHeader(){
    let addr=this.props.ticket
    let key=this.props.index
    await window.ethereum.enable().then(async function (accounts) {
        let metafound=false
        let mtdt
        const { REACT_APP_METAABI } = await process.env;
        const { REACT_APP_META } = await  process.env;
        
        const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
        mtdt=await metadata.methods.meta(addr).call()
        if(mtdt.length>=0)metafound=true
        console.log("MTDT>>>>Z> "+addr+" "+REACT_APP_META,mtdt)
        
        

               
        if(mtdt.length>0){
            console.log("MTDT",mtdt)
            fetch(formatURL(mtdt)).then(response => response.json()).then(
            response => {
                console.log(JSON.stringify(response))
                document.getElementById("Shop_header_mainlabel_"+key).textContent=response[0]["name"]
                document.getElementById("Shop_header_description_"+key).textContent=response[0]["description"]
                let back=response[0]["image"]
                if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                
                document.getElementById("Shop_header_image_"+key).style.backgroundImage='url('+back+')'

            })
        }

    })
}

setCookie(cname, cvalue,id) {

if(cvalue!="undefined"){
    let s=this.getCookie(cname)
    let arr=s.split(",")
    let arr2=[]
    let t=false
    for(let i=0;i<arr.length;i++){
      
        if(arr[i]==cvalue+"_"+id){
            t=true  
        }else{
            arr2.push(arr[i])       
        }
    }
    
    if(t){
        this.setState({favorite:false})
    document.getElementById("fav_shop_"+this.props.ticket).style.opacity=0.3
    }
    if(!t){
        arr2.push(cvalue+"_"+id)
        this.setState({favorite:true})
        document.getElementById("fav_shop_"+this.props.ticket).style.opacity=1
    }
    document.cookie = cname + "=" + arr2.toString() + "; path=/"
 
this.render()

}else{alert("UNDEFINED ADDRESS")}
}

getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }






    render(props){
    let s=this.getCookie("favoriteShop")
    let arr=s.split(",")
    let favoriteShop=false
    let fav="notfavorite"
    for(let i=0;i<arr.length;i++){
        if(arr[i]==this.props.ticket+"_0")
        {
            favoriteShop=true 
            fav="favorite"
            if(!this.state.favorite)this.setState({favorite:true})
        }
    }
    
        return ( 
            <div className="Shopheader_header_row_container">
           <div id={"Shop_header_"+this.props.index} className="Shopheader_header dark darkblue" onClick={() => window.open('/smartshop/?shop='+this.props.ticket)}>
                <div id={"Shop_header_subpanel_"+this.props.index} className="Shopheader_header_subpanel light lightblue">
                    <div id={"Shop_header_image_"+this.props.index} className="Shopheader_header_image">
                        <div id={"Shop_header_mainlabel_"+this.props.index} className="Shopheader_header_mainlabel"><span id={"stakecontract"+this.props.index} aria-labelledby="jsx-a11y/accessible-emoji" role="img" onClick={() => jump()}>🌈 </span> SmartShop</div>   
                    </div>
                    <div id={"Shop_header_description_"+this.props.index} className="Shopheader_header_description dark darkblue"></div>
                </div>
            </div>
            <div id={"fav_shop_"+this.props.ticket} className={fav} onClick={() => this.setCookie("favoriteShop",this.props.ticket,0)}>❤️</div>
        </div>   
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function openProduct(ticket,index){
    
window.open("/smartshop/?shop="+ticket+"&index="+index.substr(index.lastIndexOf("x")+1,10))
}

        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

function jumpsocial(add){
    window.open(add)
}

function jump(){
    window.open('https://etherscan.io/address/0x7d410AFA45377006A0F79Ae6157A6A873Bfa5567')
}

function formatURL(url){
    return("https://gateway.ipfs.io/ipfs/"+url);
  }

export default ShopHeader